var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquarespace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 9.5c-1.1-1.1-2.9-1.1-4 0L7 14.7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l5.2-5.2c.3-.3.9-.3 1.2 0l1.4-1.4z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.3c-1.1-1.1-2.9-1.1-4 0l-7 7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l7-7c.3-.3.9-.3 1.2 0L19 12.3z",
    fill: "#FFF",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.7c1.1-1.1 2.9-1.1 4 0l5.2 5.2c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L11.6 8.1c-.3-.3-.9-.3-1.2 0L9 6.7z",
    fill: "#FFF",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarespace);
export default __webpack_public_path__ + "static/media/squarespace.1f8dcc69858009cb9fd9f8c20cd2eca4.svg";
export { ForwardRef as ReactComponent };